import { render, staticRenderFns } from "./ProductItemCreate.vue?vue&type=template&id=0b757d47&"
import script from "./ProductItemCreate.vue?vue&type=script&lang=js&"
export * from "./ProductItemCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports